import type { ResolvedFieldSelectionContext } from '#layers/data-model/utils/display-template-field-selection';
import type { IdToFieldSelectionContext } from '~/utils/id-field-selection-to-field-selection';
import { getBlockConfig, useBlockEditorLibrary } from '#layers/block-engine';
import { getDisplayTemplateFieldSelection } from '#layers/data-model/utils/display-template-field-selection';
import { useProjectSchemaStore } from '~/stores/project-schema';

export function useFieldSelectionContexts() {
	const { findCollectionById, findPrimitiveFieldById, findSingleRelationFieldById } = useProjectSchemaStore();
	const { getBlock } = useBlockEditorLibrary();

	const fieldSelectionCtx: ResolvedFieldSelectionContext = {
		getDisplayTemplateFieldSelection: (ast, collection) =>
			getDisplayTemplateFieldSelection(ast, collection, fieldSelectionCtx),
		getCollection: findCollectionById,
		getRelationField: findSingleRelationFieldById,
		resolveDisplayBlock: (displayId) => {
			const block = getBlock(displayId);
			if (block && 'comp' in block) return getBlockConfig(block);
		},
	};

	const idCtx: IdToFieldSelectionContext = {
		findPrimitiveFieldById,
		findSingleRelationFieldById,
	};

	return { fieldSelectionCtx, idCtx };
}
